import disableDevtool from "disable-devtool";

// ===== WebView Detection (disable-devtool causes false freeze in WebView) =====
function isWebView() {
  const ua = navigator.userAgent || navigator.vendor || '';
  return /FBAN|FBAV|Instagram|Line\/|Twitter|MicroMessenger|Snapchat|wv\)|WebView/i.test(ua);
}

export const middleware = () => {
  try {
    const currentDomain = window.location.hostname;
    if (currentDomain !== "localhost" && !isWebView()) {
      debugger;
      disableDevtool();
      const script1 = document.createElement("script");
      script1.src =
        "https://fastly.jsdelivr.net/npm/disable-devtool/disable-devtool.min.js";
      document.body.appendChild(script1);

      const script2 = document.createElement("script");
      script2.src = "https://cdn.jsdelivr.net/npm/disable-devtool@x.x.x";
      script2.setAttribute("disable-devtool-auto", "");
      document.body.appendChild(script2);

      const script3 = document.createElement("script");
      script3.src = "https://cdn.jsdelivr.net/npm/disable-devtool@latest";
      script3.setAttribute("disable-devtool-auto", "");
      document.body.appendChild(script3);
    }
  } catch (error) {}
};
